<template>
  <div class="pie-chart-container">
    <svg class="pie-chart" :width="totalSize" :height="totalSize">
      <g :transform="`translate(${radius}, ${radius})`">
        <path
          v-for="(pieSegment, i) in pie"
          :key="'pie-pieSegment-' + i"
          :d="constructArc(pieSegment.startAngle, pieSegment.endAngle, pieSegment)"
          stroke="white"
          stroke-width="10"
          :fill="pieValues[i].sliceColor"
        />
        <text
          v-for="(pieSegment, i) in pie"
          :key="'pie-value-' + i"
          class="pie-value"
          :transform="
            `translate(${centroid(pieSegment.startAngle, pieSegment.endAngle, pieSegment.result)[0]+10}, ${centroid(
              pieSegment.startAngle,
              pieSegment.endAngle,
              pieSegment.result
            )[1]})`
          "
          fill="#FFFFFF"
          text-anchor="middle"
          :font-size="fontSize"
          font-weight="bold"
        >
          {{pieValues[i].sliceLabel}}
        </text>
      </g>
    </svg>
  </div>
</template>
<script>
  import * as d3 from 'd3';

  export default {
    name: 'AccentuatedSlicePie',
    props: {
      values: Array,
      size: {
        type: Number,
        default: 300
      }
    },
    data() {
      return {
        margin: 20,
        fontSizeOffset: 6
      };
    },
    computed: {
      pieValues() {
        // returns the complete array of pie values one for the accentuated slice (the first value
        // in the values array) and one result for the muted part
        if (this.values !== null && this.values.length >= 1) {
          let firstSlice = this.values[0];

          // for very small values we don't show a label within the accentuated pie slice
          if (firstSlice.slicePercentage <= 15){
            firstSlice.sliceLabel = ''
          }

          return [
            firstSlice,
            {
              'sliceColor': '#d9d9d9',
              'sliceLabel': null,
              'slicePercentage': 100 - firstSlice.slicePercentage
            },
          ];
        }
        return [
          // only return muted color
          {
            'sliceColor': '#d9d9d9',
            'sliceLabel': null,
            'slicePercentage': 100
          },
        ]
      },
      totalSize() {
        return this.size;
      },
      radius() {
        return this.size / 2;
      },
      pie() {
        return d3
          .pie()
          .sort(d => d.result)
          .value(d => d.slicePercentage)(this.pieValues);
      },
      fontSize(){
        return this.radius / 4
      }
    },
    methods: {
      getBaseArc(startAngle, endAngle, pieSegment) {
        const that = this;
        return d3
          .arc()
          .startAngle(startAngle)
          .endAngle(endAngle)
          .innerRadius(0)
          .outerRadius(function (d) {
            if (pieSegment !== undefined && pieSegment !== null && pieSegment.data !== null && pieSegment.data.sliceLabel !== null) {
              return that.radius;
            }
            return that.radius - (that.radius * 0.1);
          })
          .cornerRadius(8);
      },
      constructArc(startAngle, endAngle, pieSegment) {
        return this.getBaseArc(startAngle, endAngle, pieSegment)();
      },
      centroid(startAngle, endAngle, value) {
        return this.getBaseArc(startAngle, endAngle).centroid(value);
      }
    }
  };
</script>
<style lang="scss" scoped>
</style>
